import React from 'react';
import type { Density, FieldGroup } from '../../types/disclosure';
import { FieldList } from './FieldList';
interface FieldGroupBlockProps {
  group: FieldGroup;
  density: Density;
  showApiNames: boolean;
  /** Max number of balanced columns to spread the fields across on wide screens. */
  columns?: 1 | 2 | 3;
}
const COLUMN_CLASS: Record<1 | 2 | 3, string> = {
  1: '',
  2: 'md:grid-cols-2',
  3: 'md:grid-cols-2 xl:grid-cols-3'
};
function chunk<T>(items: T[], parts: number): T[][] {
  const size = Math.ceil(items.length / parts);
  const result: T[][] = [];
  for (let i = 0; i < items.length; i += size) {
    result.push(items.slice(i, i + size));
  }
  return result;
}
export function FieldGroupBlock({
  group,
  density,
  showApiNames,
  columns = 1
}: FieldGroupBlockProps) {
  const effectiveColumns = (group.fields.length >= 6 ? columns : 1) as 1 | 2 | 3;
  const groups = chunk(group.fields, effectiveColumns);
  return <div data-id="element-1" data-mp="22r0d5m9esixz">
      {(group.title || group.description || group.condition) && <div className="mb-1 flex flex-wrap items-baseline gap-x-2 gap-y-0.5" data-id="element-2" data-mp="3ircxb0vycee3">
          {group.title && <h4 className="text-[11px] font-semibold uppercase tracking-wide text-slate-500" data-id="element-3" data-mp="3erulqvq0tfnx">{group.title}</h4>}
          {group.condition && <span className="rounded-full bg-blue-50 px-2 py-0.5 text-[11px] font-medium text-blue-700 ring-1 ring-inset ring-blue-100" data-id="element-4" data-mp="3nr7luxs98rvz">
              {group.condition}
            </span>}
          {group.description && <p className="w-full text-xs text-slate-500" data-id="element-5" data-mp="1kj0riugjlh5">{group.description}</p>}
        </div>}

      <div className={`grid gap-x-8 ${COLUMN_CLASS[effectiveColumns]}`} data-id="element-6" data-mp="fbnvc6iyxnkm">
        {groups.map((fields, index) => <FieldList key={fields[0]?.api ?? index} fields={fields} density={density} showApiNames={showApiNames} data-id="element-7" data-mp="adcom4nyzt6m" data-mpi={index} />)}
      </div>
    </div>;
}